import { combineEpics } from "redux-observable";
import { searchEpics } from "./searchEpics";

const rootEpic = combineEpics(searchEpics);
export default rootEpic;
